class ProductViewEventListener {
    // Language: javascript
    // Path: ProductViewEventListener.js
    // Compare this snippet from EventListener.js:

    get ProductAddCart() {
        return ".product-add-to-cart";
    }
    get AllDetailProductSelector() {
        return "gtm-add-to-cart";
    }
    get DefaultEventName() {
        return "click";
    }

    constructor(element, eventName = this.DefaultEventName) {
        this.element = element;
        this.eventName = eventName;
    }

    callback() {
        const dataLayer = new DataLayer();
        dataLayer.clear();

        var addCartProduct = document.querySelector(this.ProductAddCart);

        var allProduct = addCartProduct
            ? addCartProduct.getElementsByClassName(
                  this.AllDetailProductSelector
              )
            : document.getElementsByClassName(this.AllDetailProductSelector);

        var allProductArry = [...allProduct];
        var items = [];
        var headPrice = 0.0;
        const key = "code";
        const arrayUniqueByKey = [
            ...new Map(
                allProductArry.map((item) => [item.dataset[key], item])
            ).values(),
        ];

        for (const product of arrayUniqueByKey) {
            if (
                arrayUniqueByKey.length == 1 ||
                !product.classList.value.contains("main buton-main")
            ) {
                var analyticsData = product.dataset.analytics
                    ? JSON.parse(product.dataset.analytics)
                    : null;
                if (analyticsData && product.dataset) {
                    var analticsDataProducts = analyticsData.products
                        ? analyticsData.products[0]
                        : null;

                    var price = Number(
                        product.dataset.price.replace(",", ".")
                    ).toFixed(2);
                    var pricewithdiscount = Number(
                        product.dataset.priceWithDiscount.replace(",", ".")
                    ).toFixed(2);
                    headPrice = pricewithdiscount;
                    var quantity = product.classList.value.contains(
                        "out-of-stock"
                    )
                        ? 0
                        : product.dataset.quantity;
                    var item = {
                        item_id: product.dataset.code,
                        item_name: analticsDataProducts.name,
                        currency: analticsDataProducts.currency,
                        item_brand: analticsDataProducts.brand,
                        item_category: analticsDataProducts.category,
                        price: pricewithdiscount,
                        quantity: quantity,
                    };

                    if (analticsDataProducts.categories) {
                        var splitCategories =
                            analticsDataProducts.categories.split(";");
                        for (var j = 0; j < splitCategories.length; j++) {
                            if (j == 0) {
                                item["item_category"] = splitCategories[j];
                            } else {
                                item["item_category" + j] = splitCategories[j];
                            }
                        }
                    }

                    if (price != pricewithdiscount) {
                        item["price"] = analticsDataProducts.price;
                        item["discount"] = (price - pricewithdiscount).toFixed(
                            2
                        );
                    }
                    if (product.dataset.variant) {
                        var variant = JSON.parse(product.dataset.variant);
                        if (variant) {
                            item["item_variant"] =
                                Object.values(variant).join(",");
                        }
                    }
                    items.push(item);
                }
            }
        }

        if (items.length > 0) {
            SendData(dataLayer);
        }

        function SendData(dataLayer) {
            dataLayer
                .push({
                    event: "view_item",
                    ecommerce: {
                        currency: currency,
                        value: headPrice,
                        items: items,
                    },
                })
                .then(() => {
                    console.log("GTM pushed view_item event");
                    setTimeout(() => {
                        var instanceActivate = new ActivateGtm();
                        instanceActivate.activateRemoveFromCart();
                    }, 2000);
                })
                .catch((error) => {
                    console.warn("GTM error view_item event", error);
                });

            if (typeof gtag !== "undefined" && !!gtag) {
                gtag("event", "view_item", {
                    event_category: "Enhanced Ecommerce",
                    event_label: "view item",
                    value: headPrice,
                    currency: currency,
                    items: items,
                });
            }
        }
    }

    listen() {
        this.element.addEventListener(
            this.eventName,
            ProductViewEventListener.prototype.callback
        );
    }

    remove() {
        this.element.removeEventListener(
            this.eventName,
            ProductViewEventListener.prototype.callback
        );
    }
}
